import React from 'react';
import './poem.scss';

import PageContainer from '../PageContainer';
import { ReactComponent as DoubleQuote } from '../images/doubleQuote2.svg';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { greyText, red } from '../styles';
import { faArrowLeft, faHandPointer, faInfo, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as MobileFeather } from '../home/mobile-feather.svg';
import { MediaQueryContext } from '../MediaQueryContext';
import PageTitle from '../PageTitle';

export class FullPoem extends React.Component {
  static contextType = MediaQueryContext;

  render() {
    return (
      <PageContainer {...this.props} className="full-poem">
        {this.context.isMobile && <MobileFeather className="mobile-feather" />}

        <div className="full-poem-content">
          <div className="poem">
            <DoubleQuote className="quote" />
            <h1>SKIN REMEMBERS</h1>
            <p>
              <span><span className="skin-remembers">Skin remembers &nbsp;</span>how long the years grow</span>
              <span>when skin is not touched, a gray tunnel</span>
              <span>of singleness, feather lost from the tail</span>
              <span>of a bird, swirling onto a step,</span>
              <span>swept away by someone who never saw</span>
              <span>it was a feather. Skin ate, walked,</span>
              <span>slept by itself, knew how to raise a</span>
              <span>see-you-later hand. But skin felt</span>
              <span>it was never seen, never known as</span>
              <span>a land on the map, nose like a city,</span>
              <span>hip like a city, gleaming dome of the mosque</span>
              <span>and the hundred corridors of cinnamon and rope.</span>
              <span>Skin had hope, that’s what skin does.</span>
              <span>Heals over the scarred place, makes a road.</span>
              <span>Love means you breathe in two countries.</span>
              <span>And skin remembers--silk, spiny grass,</span>
              <span>deep in the pocket that is skin’s secret own.</span>
              <span>Even now, when skin is not alone,</span>
              <span>it remembers being alone and thanks something larger</span>
              <span>that there are travelers, that people go places</span>
              <span>larger than themselves.</span>
            </p>
            {this.context.isMobile && <div style={{ textAlign: 'center' }}>
              <span>“Two Countries” by Naomi Shihab Nye,</span>  <i>Everything Comes Next - Collected & New Poems</i><span>, Greenwillow, 2020</span><br />
            </div>}
          </div>
          <div className="menu">
            <ul onClick={this.toggle}>
              <li><Link to="/"><FontAwesomeIcon color={red} icon={faArrowLeft} /><span>FRONT PAGE</span></Link></li>
              <li><Link to="/stations"><FontAwesomeIcon color={red} icon={faHandPointer} /><span>CHOOSE STATION</span></Link></li>
              <li><Link to="/about"><FontAwesomeIcon color={red} icon={faInfo} /><span>ABOUT</span></Link></li>
              <li><a href="https://beheard.no"><FontAwesomeIcon color={red} icon={faQuoteLeft} /><span>BEHEARD.NO</span></a></li>
            </ul>
            <div className="page-subtitle">
              <span>“Two Countries” by Naomi Shihab Nye,</span>  <i>Everything Comes Next - Collected & New Poems</i><span>, Greenwillow, 2020</span><br />
            </div>
          </div>
        </div>


      </PageContainer>
    );
  }
}

export default withRouter(FullPoem);
